import Vue from 'vue'
import Vuex from 'vuex'

import timeline from './store/timeline';
import projects from './store/projects';
import gemeenten from './store/gemeenten';
import wijken from './store/wijken';
import themas from './store/themas';
import partijen from './store/partijen';
import segments from './store/segments';

import generatedData from './data.json';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: [
    timeline,
    projects,
    gemeenten,
    wijken,
    themas,
    partijen,
    segments
  ],
  state: {
    extended: false,
    sidepanel: 'PlatformSlider',
    data: generatedData
  },
  mutations: {
    extended_set(state, { extended }) {
      state.extended = !! extended;
    },
    sidepanel_set(state, { panel }) {
      state.sidepanel = panel;
    },
  },
  actions: {
    extended_set(context, { extended }) {
      context.commit('extended_set', { extended });
    },
    sidepanel_set(context, { panel }) {
      context.commit('sidepanel_set', { panel });
    },
  }
}) 
 